import { useEffect, useRef } from "react";
import { useLocation } from "react-router-dom";
import { trackMetaCustomEvent } from "@/lib/metaPixel";

/**
 * AnalyticsTracker
 *
 * Fires one Meta custom event — IntakeStepView — whenever the user
 * navigates to a new intake step (i.e. the URL hash changes).
 *
 * It does NOT fire on the initial page render (the first mount),
 * because the initial PageView is already handled by the Meta Pixel
 * script in index.html via fbq("track", "PageView").
 *
 * No Google Analytics / ReactGA pageview calls are made here.
 */
export const AnalyticsTracker = () => {
  const location = useLocation();
  const isMounted = useRef(false);

  useEffect(() => {
    // Skip the very first render — the initial PageView in index.html covers it.
    if (!isMounted.current) {
      isMounted.current = true;
      return;
    }

    const stepName = location.hash.replace(/^#/, "").trim();
    if (!stepName) return;

    trackMetaCustomEvent("IntakeStepView", {
      step_name: stepName,
      path: `${location.pathname}${location.search}`,
    });
  }, [location]);

  return null;
};
